<div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
    <div class="col-8 plan-list">
        <form [formGroup]="pendingActionPlansForm">
            <label class="ques p-0" [ngClass]="isArabic ? 'rightAlign' : ''">
                <span *ngIf="!isArabic">Please select an Action Plan :</span>
                <span *ngIf="isArabic">: الرجاء تحديد خطة العمل</span>
            </label>
            <div class="ans-pnl">
                <select class="form-select" (change)="selectActionPlan($event)" formControlName="pendingActionPlan"
                    [ngClass]="isArabic ? 'rightAlign' : ''">
                    <option value=""><span *ngIf="!isArabic">Select Option</span><span *ngIf="isArabic">اختر خياراً</span>
                    </option>
                    <option *ngFor="let pendingPlan of pendingActionPlansList; let i=index;"
                        [value]="pendingPlan.actionPlanId">{{pendingPlan.actionPlanName}}</option>
                </select>
            </div>
        </form>
    </div>
    <div class="col-6">
    </div>
</div>